import React from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Spinner } from '@televet/kibble-ui/build/components/Spinner';

export const AutomationsLoadingState = (): JSX.Element => {
  return (
    <Flex
      pos="absolute"
      top="0"
      left="0"
      height="100%"
      width="100%"
      align="center"
      justify="center"
      className="Automations__LoadingState"
      zIndex="overlay"
      bg="background.subtle"
    >
      <Spinner />
    </Flex>
  );
};
